module.exports = __webpack_public_path__ + "assets/img/15-s.63970c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/15-s.jpg
// module id = 5bsd
// module chunks = 0